import React from 'react';

import './input.css'

export default function Input({
    type = 'text',
    label,
    name,
    value,
    setValue,
    placeholder = '',
    required = false,
    maxLength,
    rows = 7,
    directionrtl = false,
    spellCheck = false,
    disabled = false,
    ...props
}) {

    let input = null;

    if (type == 'text') {
        input = (
            <input
                className='input'
                type='text'
                name={name}
                placeholder={placeholder}
                maxLength={maxLength}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                spellCheck={spellCheck}
                disabled={disabled}
                {...props}
            />
        );
    }

    if (type == 'number') {
        input = (
            <input
                className='input'
                type='number'
                name={name}
                placeholder={placeholder}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'email') {
        input = (
            <input
                className='input'
                type='email'
                name={name}
                placeholder={placeholder}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'tel') {
        input = (
            <input
                className='input'
                type='tel'
                name={name}
                placeholder={placeholder}
                maxLength={maxLength}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'url') {
        input = (
            <input
                className='input'
                type='url'
                name={name}
                placeholder={placeholder}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'password') {
        input = (
            <input
                className='input'
                type='password'
                name={name}
                placeholder={placeholder}
                maxLength={maxLength}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'search') {
        input = (
            <input
                className='input'
                type='search'
                name={name}
                placeholder={placeholder}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'date') {
        input = (
            <input
                className='input'
                type='date'
                name={name}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'time') {
        input = (
            <input
                className='input'
                type='time'
                name={name}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'datetime-local') {
        input = (
            <input
                className='input'
                type='datetime-local'
                name={name}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'month') {
        input = (
            <input
                className='input'
                type='month'
                name={name}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'week') {
        input = (
            <input
                className='input'
                type='week'
                name={name}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'color') {
        input = (
            <input
                className='input'
                type='color'
                name={name}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'range') {
        input = (
            <input
                className='input'
                type='range'
                name={name}
                onChange={e => setValue(e.target.value)}
                value={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'file') {
        input = (
            <input
                className='input'
                type='file'
                name={name}
                onChange={e => setValue(e.target.value)}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'checkbox') {
        input = (
            <input
                className='input'
                type='checkbox'
                name={name}
                onChange={e => setValue(e.target.value)}
                checked={value}
                required={required}
                {...props}
            />
        );
    }

    if (type == 'radio') {
        input = (
            <input
                className='input'
                type='radio'
                name={name}
                onChange={e => setValue(e.target.value)}
                checked={value}
                required={required}
                {...props}
            />
        );
    }

    return (
        <div className='inputgroup'>
            <div className='inputlabel'>{label} </div>
            {input}
        </div>
    );
}